import Customer from "models/Customer";
import CustomerAdmin from "models/CustomerAdmin";
import Survey from "models/Survey";

// CustomerDetail types
export const SET = "customDetail/SET";
export const INIT = "customDetail/INIT";

// CustomerInfo types
export const CHANGE_TAB = "customDetail/CHANGE_TAB";

// CustomerModal types
export const OPEN_CUSTOMER_MODAL = "customDetail/OPEN_CUSTOMER_MODAL";
export const CLOSE_CUSTOMER_MODAL = "customDetail/CLOSE_CUSTOMER_MODAL";
export const CHANGE_CUSTOMER_MODAL_FORM =
  "customDetail/CHANGE_CUSTOMER_MODAL_FORM";
export const SET_CUSTOMER_MODAL_ERRORS =
  "customDetail/SET_CUSTOMER_MODAL_ERRORS";
export const CHANGE_CUSTOMER_MODAL_SELECTED_LOCALES =
  "customDetail/CHANGE_CUSTOMER_MODAL_SELECTED_LOCALES";

// CustomerAdminModal types
export const OPEN_CUSTOMER_ADMIN_MODAL =
  "customerDetail/OPEN_CUSTOMER_ADMIN_MODAL";
export const CLOSE_CUSTOMER_ADMIN_MODAL = "CLOSE_CUSTOMER_ADMIN_MODAL";
export const CHANGE_CUSTOMER_ADMIN_MODAL_FORM =
  "customDetail/CHANGE_CUSTOMER_ADMIN_MODAL_FORM";
export const SET_CUSTOMER_ADMIN_MODAL_ERROR =
  "customDetail/SET_CUSTOMER_ADMIN_MODAL_ERROR";

// SurveyTable types

// CustomerDetail Actions
export const setCustomerDetail = res => ({
  type: SET,
  customer: new Customer(res.customer),
  customerAdmins: res.customerAdmins.map(ca => new CustomerAdmin(ca)),
  surveys: res.surveys.map(s => new Survey(s)),
  allLocales: res.locales,
  industries: res.industries
});
export const initCustomerDetail = () => ({
  type: INIT
});

// CustomerInfo Actions
export const changeTab = tabIndex => ({
  type: CHANGE_TAB,
  tabIndex
});

// CustomerModal Actions
export const openCustomerModal = customer => ({
  type: OPEN_CUSTOMER_MODAL,
  customer
});
export const closeCustomerModal = () => ({
  type: CLOSE_CUSTOMER_MODAL
});
export const changeCustomerModalForm = (key, value) => ({
  type: CHANGE_CUSTOMER_MODAL_FORM,
  key,
  value
});
export const setCustomerModalErrors = errors => ({
  type: SET_CUSTOMER_MODAL_ERRORS,
  errors
});
export const changeCustomerModalSelectedLocales = id => ({
  type: CHANGE_CUSTOMER_MODAL_SELECTED_LOCALES,
  id
});

// CustomerAdminModal Actions
export const openCustomerAdminModal = customerAdmin => ({
  type: OPEN_CUSTOMER_ADMIN_MODAL,
  customerAdmin
});
export const closeCustomerAdminModal = () => ({
  type: CLOSE_CUSTOMER_ADMIN_MODAL
});
export const changeCustomerAdminModalForm = (key, value) => ({
  type: CHANGE_CUSTOMER_ADMIN_MODAL_FORM,
  key,
  value
});
export const setCustomerAdminModalError = errors => ({
  type: SET_CUSTOMER_ADMIN_MODAL_ERROR,
  errors
});

// SurveyTable Actions

// Reducer
const initialState = {
  customer: new Customer(),
  customerAdmins: [],
  allLocales: [],
  industries: {
    large: [],
    middle: []
  },
  tabIndex: 0,
  customerModal: {
    open: false,
    customer: new Customer()
  },
  customerAdminCard: {
    modal: {
      open: false,
      customerAdmin: new CustomerAdmin(),
      errors: []
    },
    customerAdmins: []
  },
  surveyTable: {
    surveys: []
  }
};

const customerDetail = (state = initialState, action) => {
  switch (action.type) {
    // CustomerDetail
    case SET: {
      const { customerAdmins, surveys } = action;
      const customerAdminCard = { ...state.customerAdminCard, customerAdmins };
      const surveyTable = { ...state.surveyTable, surveys };
      return { ...state, ...action, customerAdminCard, surveyTable };
    }

    case INIT: {
      return initialState;
    }

    // CustomerInfo
    case CHANGE_TAB: {
      return { ...state, tabIndex: action.tabIndex };
    }

    // CustomerModal
    case OPEN_CUSTOMER_MODAL: {
      const customerModal = {
        ...state.customerModal,
        open: true,
        customer: new Customer(action.customer),
        errors: initialState.errors
      };
      return { ...state, customerModal };
    }

    case CLOSE_CUSTOMER_MODAL: {
      const customerModal = { ...state.customerModal, open: false };
      return { ...state, customerModal };
    }

    case CHANGE_CUSTOMER_MODAL_FORM: {
      const { key, value } = action;
      const customerModal = {
        ...state.customerModal,
        customer: state.customerModal.customer.set(key, value)
      };
      return { ...state, customerModal };
    }

    case SET_CUSTOMER_MODAL_ERRORS: {
      const { errors } = action;
      const customerModal = { ...state.customerModal, errors };
      return { ...state, customerModal };
    }

    case CHANGE_CUSTOMER_MODAL_SELECTED_LOCALES: {
      const { selectedLocaleIds } = state.customerModal.customer;
      const selectedId = Number(action.id);
      let newSelectedLocales = [];

      if (selectedLocaleIds.indexOf(selectedId) > -1) {
        newSelectedLocales = selectedLocaleIds.filter(id => id !== selectedId);
      } else {
        newSelectedLocales = [...selectedLocaleIds, selectedId];
      }

      const customer = state.customerModal.customer.set(
        "selectedLocaleIds",
        newSelectedLocales
      );
      const customerModal = { ...state.customerModal, customer };
      return { ...state, customerModal };
    }

    // Customer Admin Modal
    case OPEN_CUSTOMER_ADMIN_MODAL: {
      const customerAdmin =
        action.customerAdmin ||
        new CustomerAdmin({ customerId: state.customer.id });
      const modal = {
        ...state.customerAdminCard.modal,
        open: true,
        customerAdmin,
        errors: initialState.customerAdminCard.modal.errors
      };
      const customerAdminCard = { ...state.customerAdminCard, modal };
      return { ...state, customerAdminCard };
    }

    case CLOSE_CUSTOMER_ADMIN_MODAL: {
      const modal = {
        ...state.customerAdminCard.modal,
        open: false
      };
      const customerAdminCard = { ...state.customerAdminCard, modal };
      return { ...state, customerAdminCard };
    }

    case SET_CUSTOMER_ADMIN_MODAL_ERROR: {
      const modal = { ...state.customerAdminCard.modal, errors: action.errors };
      const customerAdminCard = { ...state.customerAdminCard, modal };
      return { ...state, customerAdminCard };
    }

    case CHANGE_CUSTOMER_ADMIN_MODAL_FORM: {
      const { key, value } = action;
      const customerAdmin = state.customerAdminCard.modal.customerAdmin.set(
        key,
        value
      );
      const modal = { ...state.customerAdminCard.modal, customerAdmin };
      const customerAdminCard = { ...state.customerAdminCard, modal };
      return { ...state, customerAdminCard };
    }

    // SurveyTable

    default:
      return state;
  }
};

export default customerDetail;



// WEBPACK FOOTER //
// ./src/redux/modules/customerDetail.js